import React from "react";
import { noop } from "lodash";
import { MessageContentFile } from "./MessageContentFile";
import { FILE_UPLOAD_TYPE } from "@/config/constants";
import FilePdf from "@/assets/images/file-icons/pdf.png";
import FileJpeg from "@/assets/images/file-icons/jpeg.png";
import FilePng from "@/assets/images/file-icons/png.png";

export const MessageFile = ({ file, onClear = noop, isInput = false }) => {
	const fs = {
		[FILE_UPLOAD_TYPE.JPEG]: <MessageContentFile icon={FileJpeg} file={file} isInput={isInput} onClear={onClear} />,
		[FILE_UPLOAD_TYPE.PNG]: <MessageContentFile icon={FilePng} file={file} isInput={isInput} onClear={onClear} />,
		[FILE_UPLOAD_TYPE.PDF]: <MessageContentFile icon={FilePdf} file={file} isInput={isInput} onClear={onClear} />,
	};

	return (
		<>
			{file &&
				(isInput ? (
					fs[file?.type] ? (
						fs[file?.type]
					) : (
						<MessageContentFile icon={FileGeneral} file={file} isInput={isInput} onClear={onClear} />
					)
				) : (
					(fs[file?.mimetype] ?? (
						<MessageContentFile icon={FileGeneral} file={file} isInput={isInput} onClear={onClear} />
					))
				))}
		</>
	);
};
